import { http } from '@/http/axios.js'
export function getListAPI(params) {
  return http({
    url: '/adminapi/log/action/page',
    method: 'get',
    params
  })
}
